import React, { useState } from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from "../ui/alert-dialog";

export const hasAnswers = (obj) =>
  Object.values(obj || {}).some((v) =>
    Array.isArray(v) ? v.length > 0 : typeof v === "boolean" ? v : v !== "" && v != null
  );

export function useBackGuard(dirty, onBack) {
  const [open, setOpen] = useState(false);
  const requestBack = () => (dirty ? setOpen(true) : onBack());

  const dialog = (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent data-testid="back-confirm-dialog" className="rounded-sm">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-serif text-brand-black">Change the type of help?</AlertDialogTitle>
          <AlertDialogDescription>
            Your answers on this page are saved automatically. If you go back and choose a different
            type of help, you can return to this one at any time and your answers will still be here.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="back-confirm-cancel" className="rounded-sm border-brand-darkgrey">
            Stay on this page
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="back-confirm-leave"
            onClick={onBack}
            className="rounded-sm bg-brand-black text-white hover:bg-brand-gold"
          >
            Go back
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );

  return { requestBack, dialog };
}
